package features.members.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object BulkDeleteModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "bulk-delete-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold text-red-400") { +"Delete Members" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("mb-6") {
                    p("text-slate-400 mb-4") {
                        id = "bulk-delete-count"
                        +"You are about to delete selected members"
                    }
                    
                    div("max-h-48 overflow-y-auto pr-2 custom-scrollbar mb-4") {
                        id = "bulk-delete-list"
                        // Will be populated dynamically
                    }
                    
                    div("p-3 bg-red-500/10 border border-red-500/30 rounded-lg") {
                        p("text-sm text-red-400") {
                            +"⚠️ This action cannot be undone. All member data will be permanently deleted."
                        }
                    }
                }
                
                div("flex justify-end gap-3") {
                    button(classes = "px-4 py-2 rounded-xl text-slate-300 hover:bg-dark-700 transition") {
                        onClickFunction = { ModalManager.close() }
                        +"Cancel"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition") {
                        onClickFunction = { js("confirmBulkDelete")() }
                        +"Delete All"
                    }
                }
            }
        }
    }
}
